import { useAppSelector } from 'hooks/reduxHooks'
import { APPLY_URL, EMPLOYEE_APPLY_URL } from 'loyalty/pages/loyaltyCreditCardPage/loyaltyCreditCardConstants'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { isLEStaff } from 'selectors/accountSelectors'

/**
 * Single source of the application link for every apply CTA on the Société
 * Credit Card page, so employees are sent to their own form and everyone else
 * to the public one. Resolving to a single URL here keeps the other URL out of
 * the rendered markup entirely.
 */
export function useLoyaltyCreditCardApplyUrl(): string {
  const isStaff = useAppSelector(isLEStaff)
  const { search } = useLocation()
  const baseApplyUrl = isStaff ? EMPLOYEE_APPLY_URL : APPLY_URL

  return useMemo(() => {
    const applyUrl = new URL(baseApplyUrl)
    const pageSearchParams = new URLSearchParams(search)

    for (const [key, value] of pageSearchParams) {
      if (!applyUrl.searchParams.has(key)) {
        applyUrl.searchParams.append(key, value)
      }
    }

    return applyUrl.toString()
  }, [baseApplyUrl, search])
}
